import { assignCartProductGroups } from '../../carts/actionCreators';
import { mergedAddresses } from '../../addressBook/selectors';

export const ADDON_ADDRESSES = 'ADDON_ADDRESSES';

export const addressesAddon = (store, action) => {
  const state = store.getState();

  switch (action.type) {
    case assignCartProductGroups.type:
      return {
        ...action,
        addon: {
          ...action.addon,
          [ADDON_ADDRESSES]: mergedAddresses(state)
        }
      };
    default:
      return action;
  }
};
